export interface NavBarTheme {
  logoColor: string;
  backgroundColor: string;
  textColor: string;
  btnTextColor: string;
}

export interface SidebarTheme {
  sideMenuActive: string;
  sideMenuInactive: string
}

export const navDefaultTheme: NavBarTheme = {
  logoColor: 'red',
  backgroundColor: 'white',
  textColor: 'black',
  btnTextColor: 'black'
};

export const navLightTheme: NavBarTheme = {
  logoColor: 'white',
  backgroundColor: 'white',
  textColor: 'black',
  btnTextColor: 'black'
};

export const navDarkTheme: NavBarTheme = {
  logoColor: 'red',
  backgroundColor: 'black',
  textColor: 'white',
  btnTextColor: 'white'
};

export const sideLightTheme: SidebarTheme = {
  sideMenuActive: '#fff',
  sideMenuInactive: 'rgba(255, 255, 255, 0.6)',
};

export const sideDarkTheme: SidebarTheme = {
  sideMenuActive: '#546e7a',
  sideMenuInactive: '#b0bec5',
};

export const navMiscTheme: NavBarTheme = {
  logoColor: 'red',
  backgroundColor: 'white',
  textColor: 'white',
  btnTextColor: 'black'
};

export const getOldTheme = (): NavBarTheme => {
  const root = document.documentElement;
  return {
    logoColor: root.style.getPropertyValue('--ikone-logo'),
    backgroundColor: root.style.getPropertyValue('--ikone-btn-menu'),
    btnTextColor: root.style.getPropertyValue('--ikone-btn-menu-text'),
    textColor: root.style.getPropertyValue('--ikone-menu-text-color')
  }
};

export const changeNavbarTheme = (theme: NavBarTheme): void => {
  const root = document.documentElement;
  root.style.setProperty('--ikone-logo', `var(--ikone-logo-${theme.logoColor})`);
  root.style.setProperty('--ikone-btn-menu', theme.backgroundColor);
  root.style.setProperty('--ikone-btn-menu-text', theme.btnTextColor);
  root.style.setProperty('--ikone-menu-text-color', theme.textColor);
};
